// @mui material components
// import Grid from "@mui/material/Grid";

// import { useState } from "react";

// // Material Dashboard 2 React components
// import MDBox from "components/MDBox";
// import MDButton from "components/MDButton";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout/index.js";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar/index.js";
// import { Button } from "@mui/material";
// import { useAuth } from "context/authContext.js";
// import UserDashboard from "./components/UserDashboard/index.js";
// import Corporate from "./components/Corporate/index.js";
// import { useTranslation } from "react-i18next";
// import { useAppTheme } from "context/themeContext.js";
// import { buttonStyles } from "services/utils.js";
// import MergedDashboard from "./components/MergedDashboard/index.js";

// function DashboardView() {
//   const { t } = useTranslation();
//   const { employee } = useAuth();

//   const [view, setView] = useState(employee?.role === 1 ? 0 : 1);

//   const { primaryColor } = useAppTheme();
//   // Common button styles

//   return <MergedDashboard />;
// }

// export default DashboardView;
// @mui material components
import Grid from "@mui/material/Grid";

import { useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout/index.js";
import DashboardNavbar from "examples/Navbars/DashboardNavbar/index.js";
import { Button } from "@mui/material";
import { useAuth } from "context/authContext.js";
import UserDashboard from "./components/UserDashboard/index.js";
import Corporate from "./components/Corporate/index.js";
import { useTranslation } from "react-i18next";
import { useAppTheme } from "context/themeContext.js";
import { buttonStyles } from "services/utils.js";

function DashboardView() {
  const { t } = useTranslation();
  const { employee } = useAuth();

  const [view, setView] = useState(employee?.role === 1 ? 0 : 1);

  const { primaryColor } = useAppTheme();
  // Common button styles

  return (
    <MDBox>
      {employee?.role == 1 && (
        <MDBox>
          <Button
            sx={{ ...buttonStyles(view === 0), mr: 1 }}
            variant={view === 0 ? "contained" : "outlined"}
            onClick={() => setView(0)}
            color="primary"
          >
            {t("user.corporate")}
          </Button>
          <Button
            sx={buttonStyles(view === 1)}
            variant={view === 1 ? "contained" : "outlined"}
            onClick={() => setView(1)}
          >
            {t("user.department")}
          </Button>
        </MDBox>
      )}
      {view == 0 ? <Corporate /> : <UserDashboard />}
    </MDBox>
  );
}

export default DashboardView;
